import { css } from "@emotion/css";
import { constants } from "@newsela/angelou";

const { colors } = constants;

const coreBlue = colors.ui.core[700];
const white = colors.ui.white[700];

export const highlightCss = css({
  color: white,
  backgroundColor: coreBlue,
});
